module.exports = __webpack_public_path__ + "static/bg06-19c8af80c6b259cbd429b40a71ccd6c1.jpg";